import React from 'react'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react'
import { useStores } from 'stores'
import ContentLoader from 'common/ContentLoader'
import BundleDetailModal from './SharedBundleDetailsModel'
import Bundles from './SharedBundles'
import PrTable from './SharedPrTable'
import PrViewModal from 'components/Case/CaseDetail/PurchaseRequest/PrViewModal'

export default observer(() => {
    const { key } = useParams()
    const { sharedProposalStore } = useStores()
    const [prViewModalOption, setPrViewModalOption] = React.useState({})
    const [bundleModalOption, setBundleModalOption] = React.useState({})

    const {
        Table: { data, loading }
    } = sharedProposalStore

    const propose = data?.proposal || {}
    const resource = data?.resource || {}
    const caseCurrency = {
        currencySymbol: propose.currencySymbol || '€',
        currencyCode: propose.currencyCode || 'EUR'
    }

    React.useEffect(() => {
        if (key) {
            sharedProposalStore.getSharedProposal(key)
        }
    }, [key])

    const handleViewPrLine = prLine => setPrViewModalOption({ isOpen: !!prLine, prLine })
    const handleViewBundleDetail = proposeItem => setBundleModalOption({ isOpen: !!proposeItem, proposeItem })

    return (
        <div className="position-relative">
            <ContentLoader show={loading} />
            {propose.proposalBundles && (
                <React.Fragment>
                    <PrTable
                        resource={resource}
                        prData={propose.prData.purchaseRequest}
                        settings={propose.settings || {}}
                        onViewPrLine={handleViewPrLine}
                        caseCurrency={caseCurrency}
                    />
                    <hr className="triangle" />
                    <Bundles
                        resource={resource}
                        propose={propose}
                        onViewDetail={handleViewBundleDetail}
                        caseCurrency={caseCurrency}
                    />
                    {bundleModalOption.isOpen && (
                        <BundleDetailModal
                            resource={resource}
                            commonResource={resource}
                            data={bundleModalOption.proposeItem}
                            onClose={() => handleViewBundleDetail()}
                            caseCurrency={caseCurrency}
                        />
                    )}
                    {prViewModalOption.isOpen && (
                        <PrViewModal
                            resource={resource}
                            commonResource={resource}
                            caseNumber=""
                            settings={{}}
                            prLine={prViewModalOption.prLine}
                            onClose={() => handleViewPrLine()}
                        />
                    )}
                </React.Fragment>
            )}
        </div>
    )
})